
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[companySlug]/jobs/[jobSlug]",
      function () {
        return require("private-next-pages/companies/[companySlug]/jobs/[jobSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[companySlug]/jobs/[jobSlug]"])
      });
    }
  